import React, { useState } from "react";
import "./AddNewBtn.css";
import { Dropdown, Button } from "react-bootstrap";
// Using Lucide icons to match TaskPage aesthetic (Outline style)
import {
  Calendar,
  CheckSquare,
  Activity,
  FileKey, // Replaces the complex admin SVG
} from "lucide-react";

import AddEvent from "../../components/calendar/events/AddEvent";
import ModalMeet from "../../components/calendar/ModalMeet";
import LogActivityModal from "../../components/TasksPage/LogActivityModal";
import NewTask from "../../components/TasksPage/NewTask";
import AdminRequestModal from "../../components/userComponents/userProfileComponents/AdminRequestModal";

const AddNewBtn = () => {
  const [showAddEvent, setShowAddEvent] = useState<boolean>(false);
  const [showActivityModal, setShowActivityModal] = useState<boolean>(false);
  const [showAddTaskModal, setShowAddTaskModal] = useState<boolean>(false);
  const [showAdminRequestModal, setshowAdminRequestModal] =
    useState<boolean>(false);

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle as={Button} className="add-new-btn ">
        <svg className="mb-[3px]" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 14 14" fill="none">
  <path d="M12.75 6.75H6.75M6.75 6.75H0.75M6.75 6.75V0.75M6.75 6.75V12.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg> <span>Add New</span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="add-new-menu">
          <Dropdown.Item onClick={() => setShowAddEvent(true)}>
            <div className="menu-icon-wrapper">
              <Calendar />
            </div>
            <div className="menu-text-content">
              <strong>Add New Meeting</strong>
              <span className="description">Schedule a meeting</span>
            </div>
          </Dropdown.Item>

          <Dropdown.Item onClick={() => setShowAddTaskModal(true)}>
            <div className="menu-icon-wrapper">
              <CheckSquare />
            </div>
            <div className="menu-text-content">
              <strong>Add New Task</strong>
              <span className="description">Create a task</span>
            </div>
          </Dropdown.Item>

          <Dropdown.Item onClick={() => setShowActivityModal(true)}>
            <div className="menu-icon-wrapper">
              <Activity />
            </div>
            <div className="menu-text-content">
              <strong>Add Activity</strong>
              <span className="description">Log activity in task</span>
            </div>
          </Dropdown.Item>

          <Dropdown.Item onClick={() => setshowAdminRequestModal(true)}>
            <div className="menu-icon-wrapper">
              {/* FileKey or FileText matches the outline style better than the filled pink SVG */}
              <FileKey />
            </div>
            <div className="menu-text-content">
              <strong>Add Admin Request</strong>
              <span className="description">Request time off, file</span>
            </div>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      {/* Modals remain unchanged */}
      {showAddEvent && (
        <ModalMeet isOpen={showAddEvent} onClose={() => setShowAddEvent(false)}>
          <AddEvent event={null} onClose={() => setShowAddEvent(false)} />
        </ModalMeet>
      )}

      {showActivityModal && (
        <ModalMeet
          isOpen={showActivityModal}
          onClose={() => setShowActivityModal(false)}
          widthClass="max-w-[600px]"
        >
          <LogActivityModal onClose={() => setShowActivityModal(false)} />
        </ModalMeet>
      )}

      {showAddTaskModal && (
        <ModalMeet
          isOpen={showAddTaskModal}
          onClose={() => setShowAddTaskModal(false)}
          widthClass="max-w-[600px]"
        >
          <NewTask onClose={() => setShowAddTaskModal(false)} />
        </ModalMeet>
      )}

      {showAdminRequestModal && (
        <AdminRequestModal
          handleClose={() => setshowAdminRequestModal(false)}
          show={showAdminRequestModal}
        />
      )}
    </>
  );
};

export default AddNewBtn;
